import { ROOT_STATUS } from ".";

export const STATUSES = {
  ...ROOT_STATUS,
  STATUS_CREATED : {
    key: 'STATUS_CREATED',
    value: 'Created',
    color: 'secondary',
    icon: '',
  },
  STATUS_AWAIT_CANDIDATE_RESPONSE : {
    key: 'STATUS_AWAIT_CANDIDATE_RESPONSE',
    value: 'Awaiting Candidate Response',
    color: 'warning',
    icon: '',
  },
  STATUS_AWAIT_CONFIRMED_POLICY : {
    key: 'STATUS_AWAIT_CONFIRMED_POLICY',
    value: 'Pending acceptance of Terms and Conditions',
    color: 'info',
    icon: '',
  },
  STATUS_AWAIT_PAYMENT : {
    key: 'STATUS_AWAIT_PAYMENT',
    value: 'Awaiting Payment',
    color: 'blue-grey',
    icon: '',
  },
  STATUS_AWAIT_START : {
    key: 'STATUS_AWAIT_START',
    value: 'Pending Response',
    color: 'cyan',
    icon: '',
  },
  STATUS_CANDIDATE_INPUTTING : {
    key: 'STATUS_CANDIDATE_INPUTTING',
    value: 'Candidate Inputting',
    color: 'primary',
    icon: '',
  },
  STATUS_COMPLETED : {
    key: 'STATUS_COMPLETED',
    value: 'Complete',
    color: 'success',
    icon: '',
  },
  STATUS_CANCEL : {
    key: 'STATUS_CANCEL',
    value: 'Awaiting Candidate Response',
    color: 'error',
    icon: '',
  },
  STATUS_EXCEPTION: {
    key: 'STATUS_EXCEPTION',
    value: 'Exception',
    color: 'error',
    icon: ''
  },
  STATUS_AWAIT_RESULT: {
    key: 'STATUS_AWAIT_RESULT',
    value: 'Awaiting Result',
    color: 'secondary',
    icon: ''
  }
}